import script from "./task.vue?vue&type=script&setup=true&lang=js"
export * from "./task.vue?vue&type=script&setup=true&lang=js"

import "./task.vue?vue&type=style&index=0&id=a8149c94&scoped=true&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a8149c94"]])

export default __exports__